# MAGIC_DESPROCKET_START
#   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
#
#   For details and info on using this file see the wiki:
#     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
#
#   STATUS: some manual tweaks, but dependencies not fixed (and also imported outside of webpack)
#   LOADERS:
#   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
# MAGIC_DESPROCKET_END

# Be careful with this class; it is backed by different
# serializers in different instances, which means that
# we can only rely on the presence of id, display_name,
# and url from the base UserSerializer.
class User
  @users = {}

  @set_current: (json) ->
    @current = @from_json json

  @set_viewed: (json) ->
    @viewed = @from_json json

  @from_json: (json) ->
    json = JSON.parse(json) if typeof json == 'string'

    id = json.id
    throw "id is required" unless id?

    if id of @users
      @users[id].set_attrs json
    else
      @users[id] = new User(json)

  constructor: (json) ->
    @set_attrs json

  set_attrs: (json) ->
    _.extend @, json

    if @first_name? and @last_name?
      @display_name = "#{@first_name} #{@last_name}"
    else
      throw "first and last name are required"

    if @domain_name? and @page_name?
      @url = $r.new_profile_url(subdomain: @domain_name, page_name: @page_name)
    else
      throw "subdomain and page are required"

    @

  is_affiliated: ->
    @domain_name != 'independent'

  update_url: (url) ->
    @url = url
    [@domain_name, @page_name] = url.replace(/https?:\/\//, '').split('.'+$app_host+'/')

  affiliationString: (options = {}) ->
    @affiliation().toString(options)

  # Same structure as affiliation model returned by wowprofile endpoints
  affiliation: ->
    category: (if @is_affiliated() then 'university' else 'independent')
    department: @department
    position:
      id: @position_id
      name: (@position unless @position_id == 4)
    custom_position:
      name: (@position if @position_id == 4)
    is_primary: true
    positionPlaceholder: ({useIndependentResearcherFallback}) =>
      useIndependentResearcherFallback ?= true
      if useIndependentResearcherFallback
        "Independent Researcher" # TODO(Patrick): Remove? Would affect a lot of things.
      else
        ""

    toString: (options = {}) ->
      if @department
        [
          @department.university.name
          (@position.name || @custom_position.name)
          @department.name
        ].join(', ')
      else
        @positionPlaceholder(options)

  has_teaching_position: ->
    @position_id in [1,2,3,6,9]

  isPremium: ->
    @premium

  is_analytics_visible: ->
    @is_analytics_public or @is_current_user()

  message_me_path: ->
    "/Messages?recipient=#{@id}"

  is_current_user: ->
    @constructor.current?.id == @id

  is_viewed_user: ->
    @constructor.viewed?.id == @id

  load_followers_count: ->
    @_load_async_attr(
      'followers_count',
      $r.api_v0_user_followers_url(user_id: @id, limit: 0),
      (data) -> data.meta.count
    )

  load_works_count: ->
    @_load_async_attr(
      'works_count',
      $r.count_api_v0_user_works_url(user_id: @id),
      (data) -> data.count
    )

  load_suggestions_count: ->
    @_load_async_attr(
      'suggestions_count',
      $r.api_v0_suggestions_following_index_path(count: 6, grouped: true, subdomain_param: 'api'),
      (data) -> data
    )

  load_views_counts: ->
    @_load_async_attr(
      'views_counts',
      $r.api_v0_user_stats_url(user_id: @id),
      (data) -> data
    )

  _load_async_attr: (attr, url, value_from_data) ->
    @_async_attr_promises or= {}
    @_async_attr_promises[attr] or= $.ajax(url: url, dataType: 'jsonp')

    promise = new $.Deferred
    @_async_attr_promises[attr].done (data) ->
      promise.resolve value_from_data(data)
    promise

# It would be nicer to do this someplace else
try
  User.set_current $current_user if $current_user?

  # Only execute in browser environment, not during SSR
  if typeof window != 'undefined'
    window.c ||= {}
    if window.Aedu
      window.Aedu.User = User

export default User
